import { inject, Injectable } from '@angular/core';
import { WIDGETS_B2C_API_URL } from '../tokens/widgets-b2c-api-url.token';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private readonly apiUrl = inject(WIDGETS_B2C_API_URL);

  getBaseApiUrl(): string {
    return this.apiUrl;
  }
}
